import { extendedArea, ExtendedAreaModels } from '@bpd-library/utilities';

const extendedAreaDataHelper = () => {
    let _data: ExtendedAreaModels | undefined = undefined;

    const getData = async () => {
        if (!_data) {
            _data = await extendedArea.getData(window.__ENVIRONMENT_DETAILS__.areaId);
        }

        return _data;
    };

    const getDataUnsafe = () => {
        return _data;
    };

    return { getData, getDataUnsafe };
};

const { getData: useAreaData, getDataUnsafe: useAreaDataUnsafe } = extendedAreaDataHelper();

export { useAreaData, useAreaDataUnsafe };
